module.exports = __webpack_public_path__ + "4e8f0ec199c70edae6b76fcec0e77643.pdf";